<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
          title="Shopify Store Development Package"
          startingPrice="$19,999"
          :overview="overview"
          :bullets="bullets"
          cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'ShopifyStoreDevelopment',
  components: {
    ServicePackagesSidebar,
    ServicePackageContent,
    MobileServicePackagesList,
  },
  data() {
    return {
      overview:
        'We build your Shopify store from the ground up — designed to get you selling online quickly with a professional, responsive storefront. Perfect for businesses launching their first e-commerce website.',
      bullets: [
        'Shopify store setup with product catalog and categories',
        'Secure payment integration (Shopify Payments, Stripe, PayPal)',
        'Shipping provider setup with tax rules',
        'Basic abandoned cart automation',
        'SEO-friendly design optimized for conversions',
      ],
    };
  },
};
</script>

<style scoped>
.service-section {
  padding: 2rem 1rem;
  background: #f9fafb;
}

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col {
  min-width: 0;
}

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
